import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import PreviewBrief from '../BriefPreview';
import BackIcon from '../../../assets/images/BackArrow.svg';
import EditIcon from '../../../assets/images/EditIcon.svg';
import './style.scss';
import { TextInput, TextInputDropdown, AvailableProjects , SearchBar} from '../../../components';
import { MenuItem } from "@mui/material";
import { useServerFilter } from "../../../hooks/useServerFilter";
import { useServerFilterBriefs } from "../../../hooks/useBriefFilter";
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`

var mobile = require('is-mobile');
//{ backClick, selectedPro, leads, pros }
const ViewClient = observer(({ backClick, selectedPro, leads, pros }) => {
    const { userStore, uiStore,projectStore,briefStore, } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEdit, setIsEdit] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const [User, setUser] = useState(selectedPro);
    const [ViewProject, setViewProject] = useState(false);
    const [TypeSelected, setTypeSelected] = useState('Brief');
    const [Briefs, setBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [SelectedProject, setSelectedProject] = useState({});
    const [AllProjects, setAllProjects] = useState([]);
    const [FullName, setFullName] = useState('');
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [IsEdited, setIsEdited] = useState()
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    });
    const didMount = useRef(false);
        const { serverFilterBriefs } = useServerFilterBriefs({ briefStore, uiStore, setBriefs, setPagination, searchTerm });
        const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs:setProjects, setPagination, searchTerm });
        
    useEffect(() => {
        getUsers();
    }, [selectedPro]);
    useEffect(() => {
        if (!didMount.current) {
          // first render, do nothing
          didMount.current = true;
          return;
        }
            
        if (searchTerm !== "") {
          serverFilterProject(null, searchTerm, null, null, selectedPro._id, 1);
          serverFilterBriefs(null , searchTerm, null, selectedPro._id, 1);
        } else {
          serverFilterProject(null, null, null, null, selectedPro._id, 1);
          serverFilterBriefs(null, null, null, selectedPro._id, 1);
        }
    }, [searchTerm]);
    useEffect(() => {
        let allProjects = [...Projects, ...Briefs];
        setAllProjects(allProjects);
    }, [Projects, Briefs]);
    const getUsers = async () => {
        try {
            uiStore.setLoading(true);
            let fullName = `${selectedPro?.firstName ??""} ${selectedPro?.lastName ??""}`;
            await Promise.all([
                serverFilterProject( "", "", "","", selectedPro._id, 1),
                serverFilterBriefs( "", "","", selectedPro._id, 1)
            ]).then(() => {
                setFullName(fullName);
                setLeads(leads);
                setProfessionals(pros);
                setUser(selectedPro);
                uiStore.setLoading(false);
            }); 
        } catch (e) {
            console.error(e);
            uiStore.showNotification('Failed to load client details.', 'error');
            uiStore.setLoading(false);
        } finally {
            uiStore.setLoading(false);
        }
    };
    const truncateString = (str, num) => {
        if (str.length <= num) {
            return str;
        }
        return str.slice(0, num) + '...';
    };
    const handleTabClick = (tab) => {
        setIsEdit(false);
        setActiveTab(tab);
        forceUpdate();
    };
    const handleEditUser = () => {
        setIsEdit(true);
        forceUpdate();
    };
    const handleNavigateToMainScreen = () => {
        backClick(false, IsEdited);
        forceUpdate();
    };
    const handleTabChange = (e) => {
        setTypeSelected(e.currentTarget.id);
        forceUpdate();
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };
    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };
    const handleUserInfoChange = (e) => {
        let user = User;
        if (!Object.keys(user).includes('professional')) {
            user['professional'] = {
                gender: '',
                languages: ''
            }
        };
        if (e.currentTarget.id === 'FullName') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0] ?? '';
            user.lastName = fullName.split(' ')[1] ?? '';
            setFullName(fullName);
            user['fullName'] = `${user.firstName} ${user.lastName}`
        }
        if (e.currentTarget.id === 'Phone') {
            user.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'AccountType') {
            user.accountType = e.target.value;
        }
        if (e.currentTarget.id === 'paymentMethod') {
            user.paymentMethod = e.target.value;
        }
        if (e.currentTarget.id === 'compName') {
            User.companyName = e.target.value;
        }
        if (e.currentTarget.id === 'industry') {
            user.companyIndustry = e.target.value
        }
        if (e.currentTarget.id === 'vatnumber') {
            user.companyVatNumber = e.target.value;
        }
        if (e.currentTarget.id === 'billing') {
            user.companyAddress = e.target.value;
        }

        setUser(user);
        forceUpdate();
    };
   const updateUserClicked = async () => {
    try {
        uiStore.setLoading(true);

        let user = { ...User }; // clone to avoid direct mutation
        let id = user._id;
        delete user.briefs;
        delete user.projects;

        let update = await userStore.updateUserById(id, user);

        if (update !== 'error') {
            // Show success notification
            uiStore.showNotification('User updated successfully!', 'success');

            setIsEdit(false); // collapse edit form
            setIsEdited(true); // mark as edited if needed
        } else {
            uiStore.showNotification('Error updating user.', 'error');
        }
    } catch (e) {
        uiStore.showNotification('Error updating user.', 'error');
    } finally {
        uiStore.setLoading(false);
    }
};

    const cancelUpdateUser = () => {
        setIsEdit(false);
        forceUpdate();
    };
    const getSelectedProject = (id) => {
        let projects = [...AllProjects];
        let selectedProject = projects.find(project => project._id === id);
        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };
    const backClicked = (e, isUpdate) => {

        if (isUpdate) {
            // getUsers();
            setIsEdited(true);
            backClick(false, true);
        } else {
            setViewProject(e);
            forceUpdate();
        }
    }
    function formatCash(number) {
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    };
    function handleAccountTypeChange(e) {
        let user = { ...User }
        user.accountType = e.target.value;
        setUser(user)
    };
    function handlePaymentMethod(e) {
        let user = { ...User };
        user['paymentMethod'] = e.target.value;
        setUser(user);
    };

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <>
                {(ViewProject) ?
                    <div style={{ width: '100%', height: '100%' }}>
                        <PreviewBrief Briefs={AllProjects} setBriefs={setAllProjects} project={SelectedProject} navigateMainToPage={(e, isUpdate) => backClicked(e, isUpdate)} professionals={Professionals} leads={Leads} />
                    </div>
                    :
                    <div className='ViewUser-Container'>
                        <div className='userDetailsSection'>

                            <div className='user-info-headerSection'>
                                <img src={BackIcon} onClick={handleNavigateToMainScreen} />
                                <p>{User.firstName || ''} {User.lastName || ''}</p>
                            </div>

                            <div className='user-info-bodySection'>

                                <div className='user-profile-CompDetails'>
                                    <div className='Profile-Picture'>
                                        <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                    </div>
                                    <div className='user-oragnisationDetails'>
                                        {/* <p style={{ margin: '0px' }}>{User.companyName || ''}</p> */}
                                        <p >{User.email || ''}</p>
                                        <p style={{ margin: '0px' }}>{User.role ?? 'N/A'}</p>
                                    </div>
                                </div>

                                <div className='userEdit-AccountDetails'>
                                    <div className="tab-container">
                                        <div className="tabs">
                                            <div className={`tab ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
                                                Profile
                                            </div>
                                            {/* <div className={`tab ${activeTab === 'bank-details' ? 'active' : ''}`} onClick={() => handleTabClick('bank-details')}>
                                                Finanial Details
                                            </div> */}
                                        </div>
                                        <div className={`underline ${activeTab}`}></div>
                                    </div>
                                    <img src={EditIcon} style={{ width: '5%', cursor: 'pointer' }} onClick={handleEditUser} />
                                </div>

                                {(IsEdit && activeTab === 'profile') ?
                                    <div className='user-credentials'>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Name & Surname' placeholder='Jerry Williams' value={FullName ?? ''} id='FullName' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Email' placeholder='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput style={{ width: '47%' }} label='Contact Number' placeholder='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                            <TextInput style={{ width: '47%' }} label='Role' placeholder='Role' value={User.role} id='role' />
                                        </div>
                                        <div className='editname-Contact-Details'>
                                            <TextInput
                                                style={{ width: '47%' }}
                                                label='Total Jobs'
                                                placeholder='19'
                                                value={(User.briefCount??0) }
                                                id='totaljobs'
                                            />

                                        </div>

                                        <div className='action-section'>
                                            <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                            <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                        </div>
                                    </div>
                                    : (IsEdit && activeTab == 'bank-details') ?
                                        <div className='user-credentials'>
                                            <div className='editname-Contact-Details'>
                                                <TextInputDropdown style={{ width: '47%' }} placeholder={'public'} label={'Account Type'} value={User.accountType} onChange={handleAccountTypeChange}>
                                                    {['public', 'personal']?.map((item, i) => {
                                                        return (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        )
                                                    })}
                                                </TextInputDropdown>
                                                <TextInput style={{ width: '47%' }} label='Total Rands' placeholder='0,00' value={`ZAR ${
                                                    // formatCash(0)
                                                    ''
                                                    }`} id='TotalRands' />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInputDropdown style={{ width: '47%' }} placeholder={'EFT'} label={'Payment Method'} onChange={handlePaymentMethod} >
                                                    {['Voucher', 'EFT']?.map((item, i) => {
                                                        return (
                                                            null
                                                            // <MenuItem value={item}>{item}</MenuItem>
                                                        )
                                                    })}
                                                </TextInputDropdown>
                                                <TextInput style={{ width: '47%' }} label='VAT Number' placeholder='123456789' value={User.companyVatNumber} id='vatnumber' onChange={handleUserInfoChange} />
                                            </div>
                                            <div className='editname-Contact-Details'>
                                                <TextInput style={{ width: '47%' }} label='Company Registration' placeholder='w2eq324d5656f7' value={User.companyRegistrationNumber} id='compReg' onChange={handleUserInfoChange} />
                                                <TextInput style={{ width: '47%' }} label='Billing Address' placeholder='billing address' value={User.companyAddress} id='billing' onChange={handleUserInfoChange} />
                                            </div>
                                            <div className='action-section'>
                                                <button className='btn-Cancel' onClick={cancelUpdateUser}>Cancel</button>
                                                <button className='btn-Save' onClick={updateUserClicked}>Save</button>
                                            </div>
                                        </div>
                                        :
                                        (activeTab === 'profile') ?
                                            <div className='user-credentials'>

                                                <div className='name-contactsection'>
                                                    <div className='namesect'>
                                                        <p className='placeHolder'>Name & Surname</p>
                                                        <p className='value'>{User.firstName || ''} {' '}{User.lastName || ''}</p>
                                                    </div>
                                                    <div className='contactsect'>
                                                        <p className='placeHolder'>Email</p>
                                                        <p className='value'>{User.email || 'Not Assigned'}</p>
                                                    </div>
                                                </div>

                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Contact Number</p>
                                                        <p className='value'>{User.phone || 'Not Assigned'}</p>
                                                    </div>
                                                    <div className='rolesect' >
                                                        <p className='placeHolder'>Role</p>
                                                        <p className='value'>{User.role ?? "Not Assigned"}</p>
                                                    </div>
                                                </div>

                                                <div className='email-roleSection'>
                                                    <div className='emailsect'>
                                                        <p className='placeHolder'>Total Jobs</p>
                                                        <p className='value'>
                                                            {User?.briefCount??0}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                            : (activeTab === 'bank-details') ?
                                                <div className='user-credentials'>
                                                    <div className='name-contactsection'>
                                                        <div className='namesect'>
                                                            <p className='placeHolder'>Account Type</p>
                                                            <p className='value'> {User.accountType ?? ''}</p>
                                                        </div>
                                                        <div className='contactsect'>
                                                            <p className='placeHolder'>Total Rands</p>
                                                            <p className='value'>{`ZAR ${formatCash(0)}`}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Payment Method</p>
                                                            <p className='value'></p>
                                                        </div>
                                                        <div className='rolesect'>
                                                            <p className='placeHolder'>VAT Number</p>
                                                            <p className='value'>{User.companyVatNumber || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='email-roleSection'>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Company Registration</p>
                                                            <p className='value'>{User.companyRegistrationNumber || 'Not Assigned'}</p>
                                                        </div>
                                                        <div className='emailsect'>
                                                            <p className='placeHolder'>Billing Address</p>
                                                            <p className='value'>{User.companyAddress || 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                }

                            </div>
                        </div>
                        <div className='user-project-section'>
                            <div className='project-header-container'>
                                <p >{TypeSelected}</p>
                                <div className='search-bar-section' style={{ width: '45%' }}>
                                <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%' }}
                                />
                                </div>
                            </div>
                            {/* JOB SECTION  */}
                            <AvailableProjects
                                type={TypeSelected}
                                briefs={Briefs}
                                projects={Projects}
                                truncateString={truncateString}
                                formatDate={formatDate}
                                user={User}
                                getSelectedProject={getSelectedProject}
                                searchTerm={searchTerm}
                            />

                            <div className='viewBriefTypeSect' style={{ width: '93%' }}>
                                <div className={(TypeSelected === 'Brief' ? 'selectedType' : 'typeCard')} id='Brief' onClick={handleTabChange}>
                                    <p>Briefs</p>
                                </div>
                                <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Project' ? 'selectedType' : 'typeCard')} id='Project' onClick={handleTabChange}>
                                    <p>Projects</p>
                                </div>
                            </div>
                        </div>
                    </div >
                }
            </>
        )
    }

})

export default ViewClient;